import { render } from "./TableTwoColumn.vue?vue&type=template&id=359a9305"
import script from "./TableTwoColumn.vue?vue&type=script&lang=js"
export * from "./TableTwoColumn.vue?vue&type=script&lang=js"

import "./TableTwoColumn.vue?vue&type=style&index=0&id=359a9305&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__